exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var getUrl = require("../../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL___0___ = getUrl(require("assets/img/core/blank.png"));
// Module
exports.push([module.id, ".blank-wrap[data-v-4fcc56e9]{position:absolute}.blank-wrap .logo[data-v-4fcc56e9]{width:218px;height:157px;margin:0 auto;background:url(" + ___CSS_LOADER_URL___0___ + ");background-size:cover}.blank-wrap .title[data-v-4fcc56e9]{text-align:center;font-size:12px;color:#9ea7b4}", ""]);
